import React from 'react';

const About = () => {
    return (
        <div className='container mt-5'>
           <h2 className='text-center'>This is about page</h2> 
        </div>
    );
};

export default About;<h2>this is about page</h2>